import React from 'react';

export const StarYellow = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="fill-yellow-101"
    >
      <path d="M9.99996 14.3917L15.15 17.5L13.7833 11.6417L18.3333 7.70002L12.3416 7.19169L9.99996 1.66669L7.65829 7.19169L1.66663 7.70002L6.21663 11.6417L4.84996 17.5L9.99996 14.3917Z"></path>
    </svg>
  );
};
